import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVocabulary } from '@plone/volto/actions';
import { SelectWidget } from '@plone/volto/components';

const SemestersSelectWidget = (props) => {
  const dispatch = useDispatch();
  const semesters = useSelector((state) => state.vocabularies['lsf.semesters']);
  useEffect(() => {
    if ((semesters?.items || []).length === 0)
      dispatch(getVocabulary({ vocabNameOrURL: 'lsf.semesters' }));
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [dispatch]);

  const onChangeSemester = (elid, value) => {
    props.onChange(props.id, value);
  };

  const filteredSemesters =
    semesters &&
    semesters.items &&
    semesters.items.filter(
      (i) => !props.fromSemesterId || i.value >= props.fromSemesterId,
    );

  return filteredSemesters ? (
    <SelectWidget
      id={`${props.id}-semesters`}
      title={`Semester:`}
      choices={filteredSemesters.map((i) => [i.value, i.label])}
      onChange={onChangeSemester}
      value={props.value}
    ></SelectWidget>
  ) : (
    <></>
  );
};

export default SemestersSelectWidget;
